// IE 2026 11 02 / ODOO-349799 (group-header-value) (заказ Игоря, скрин «Конфігурація» по чипу «Вид, Підсистема»): заголовок строки-группы wijmo
// (GroupRow сгруппированного списка) печатал имя поля, значение и счётчик — «Вид: Довідники (88 елементи)». Теперь по умолчанию — ТОЛЬКО значение
// («Довідники»); прежний полный вид возвращает опция чипа группировки «Field and count» (chip.meta.fieldAndCount — в самом чипе стола, как и
// переключение Group ↔ Hierarchy), а полная информация о группе (поле, значение, число элементов, для вложенных уровней — цепочка родителей)
// показывается подсказкой по Alt+наведению (utils/altTooltip → AttrGrid.cellTooltip_html). Здесь — чистые расчёты: формат заголовка для
// flex.groupHeaderFormat (null — штатная строка культуры wijmo: «{name}: <b>{value}</b> ({count:n0} items)» с переводом «елементи»), цепочка предков
// строки-группы и разметка Alt-подсказки. Выключатель fe.ux.gridGroupHeaderValue (по умолчанию ВКЛ; false — прежний полный заголовок всегда и без Alt-подсказки).

export const GROUP_HEADER_FLAG = 'fe.ux.gridGroupHeaderValue'

export function groupHeaderValue_on(store) {
    try { return store?.setting?.(GROUP_HEADER_FLAG, true) !== false } catch (e) { return true }
}

// Опция чипа группировки: chip.meta.fieldAndCount === true — полный заголовок (поле, значение, счётчик), как до правки
export const GROUP_HEADER_OPTION = 'fieldAndCount'

export function groupHeader_fieldAndCount(chip) {
    return !!chip && !!chip.meta && chip.meta[GROUP_HEADER_OPTION] === true
}

// Формат заголовка строки-группы «только значение» (плейсхолдеры wijmo GroupRow.getGroupHeader: {name} {value} {count:n0} {level})
export const GROUP_HEADER_VALUE_FORMAT = '{value}'

// Формат для flex.groupHeaderFormat: флаг включён и опция «Field and count» выключена — только значение; иначе null — штатная строка культуры wijmo
export function groupHeader_format(flagOn, fieldAndCount) {
    return flagOn && !fieldAndCount ? GROUP_HEADER_VALUE_FORMAT : null
}

// Рендер формата, как wijmo format(): {name}, {value}, {count:n0} / {count}, {level}; null — штатная строка культуры (cultureFormat)
export function groupHeader_render(fmt, { name, value, count, level } = {}, cultureFormat) {
    const f = fmt == null ? (cultureFormat || '{name}: <b>{value}</b> ({count:n0} items)') : String(fmt)
    const n = Number(count) || 0
    return f
        .replace(/\{name\}/g, String(name ?? ''))
        .replace(/\{value\}/g, String(value ?? ''))
        .replace(/\{count(?::n0)?\}/g, String(n))
        .replace(/\{level\}/g, String(Number(level) || 0))
}

// Цепочка строки-группы irow: индексы её предков (от корня) и она сама. rowAt(i) → { group: boolean, level: number } | null.
// Предок уровня l — ближайшая ВЫШЕ строка-группа с level < текущего (строки wijmo идут в порядке дерева групп). Не группа — [].
export function groupHeader_chain(rowAt, irow) {
    const self = typeof rowAt === 'function' ? rowAt(irow) : null
    if (!self || !self.group) return []
    const out = [irow]
    let lvl = Number.isInteger(self.level) ? self.level : 0
    for (let i = irow - 1; i >= 0 && lvl > 0; i--) {
        const r = rowAt(i)
        if (r && r.group && Number.isInteger(r.level) && r.level < lvl) { out.unshift(i); lvl = r.level }
    }
    return out
}

const _esc = (s) => String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')

// Разметка Alt-подсказки группы: levels — цепочка от корня до наведённой группы, [{ field, value, count }]; у наведённой (последней) значение жирным,
// предки — обычным; внизу — число подчинённых элементов наведённой группы (tn: '{n} item' / '{n} items', перевод из словаря).
// tn / esc — словарь множественного числа и экранирование (в тестах — свои). Пустая цепочка — ''.
export function groupHeader_tipHtml(levels, { tn, esc } = {}) {
    const L = Array.isArray(levels) ? levels.filter(Boolean) : []
    if (!L.length) return ''
    const _tn = typeof tn === 'function' ? tn : (n, one, other) => (Number(n) === 1 ? one : other).replace('{n}', String(n))
    const _e = typeof esc === 'function' ? esc : _esc
    const rows = []
    for (let i = 0; i < L.length; i++) {
        const self = i === L.length - 1
        const field = _e(L[i].field ?? '')
        const value = _e(L[i].value ?? '')
        const pad = i ? ` style="padding-left:${i * 10}px"` : ''
        rows.push(`<div class="grp-tip-row${self ? ' grp-tip-self' : ''}"${pad}><span class="grp-tip-field" style="opacity:.7">${field}${field ? ':' : ''}</span> ${self ? `<b>${value}</b>` : value}</div>`)
    }
    const last = L[L.length - 1]
    const n = Number(last.count)
    if (Number.isFinite(n)) rows.push(`<div class="grp-tip-count" style="opacity:.7;margin-top:2px">${_e(_tn(n, '{n} item', '{n} items'))}</div>`)
    return `<div class="grp-tip">${rows.join('')}</div>`
}
